import { toZonedTime } from "date-fns-tz";
import StateStoreBase from "./StateStoreBase.js";
var BranchId = /* @__PURE__ */ ((BranchId2) => {
  BranchId2[BranchId2["Undefined"] = 0] = "Undefined";
  BranchId2[BranchId2["Communauto_Quebec"] = 1] = "Communauto_Quebec";
  BranchId2[BranchId2["Communauto_Ontario"] = 2] = "Communauto_Ontario";
  BranchId2[BranchId2["Communauto_Atlantic"] = 3] = "Communauto_Atlantic";
  BranchId2[BranchId2["Communauto_Paris"] = 4] = "Communauto_Paris";
  BranchId2[BranchId2["Emov"] = 5] = "Emov";
  BranchId2[BranchId2["DemoBranch"] = 6] = "DemoBranch";
  BranchId2[BranchId2["Carmine"] = 7] = "Carmine";
  BranchId2[BranchId2["EmovPortugal"] = 8] = "EmovPortugal";
  BranchId2[BranchId2["Free2Move"] = 9] = "Free2Move";
  BranchId2[BranchId2["Communauto_Alberta"] = 10] = "Communauto_Alberta";
  BranchId2[BranchId2["MTQ"] = 11] = "MTQ";
  BranchId2[BranchId2["VDM"] = 12] = "VDM";
  BranchId2[BranchId2["PEG"] = 13] = "PEG";
  BranchId2[BranchId2["Videotron"] = 14] = "Videotron";
  BranchId2[BranchId2["Modulauto"] = 15] = "Modulauto";
  return BranchId2;
})(BranchId || {});
class BaseBranchStore extends StateStoreBase {
  constructor() {
    super(...arguments);
    this.currentBranch = {
      currency: "CAD",
      id: 1,
      timeZone: "America/Toronto"
    };
  }
  get() {
    return this.currentBranch;
  }
  getCurrentTimeInBranchTimeZone() {
    return toZonedTime(
      // eslint-disable-next-line no-restricted-syntax
      (/* @__PURE__ */ new Date()).getTime(),
      this.currentBranch.timeZone
    );
  }
  getTimezone() {
    return this.currentBranch.timeZone;
  }
  populate(branch) {
    this.currentBranch = branch;
    this.notifySubscribers();
  }
}
const baseBranchStore = new BaseBranchStore();
export {
  BaseBranchStore,
  BranchId,
  baseBranchStore as default
};
//# sourceMappingURL=baseBranchStore.js.map
